module.exports = __webpack_public_path__ + "img/NL-Melani-Method-check-out-picture.1bb3de5e.png";